import { PAGE_TEMPLATE_IDS } from 'model/Article';
import { ItemSearchOperator, ItemSearchPredicateInput } from 'model/Sitecore.graphql';

export const isArticle = {
  AND: [
    {
      // /sitecore/content/Shared/Articles
      name: '_path',
      value: '2567876566B044428C3DB5C9D0E53D76',
      operator: ItemSearchOperator.Contains,
      AND: undefined,
      OR: undefined,
    },
    {
      // /sitecore/templates/Feature/Aberdeen/Article/Pages/_BaseArticle
      name: '_templates',
      value: PAGE_TEMPLATE_IDS.BaseArticle,
      operator: ItemSearchOperator.Contains,
      AND: undefined,
      OR: undefined,
    },
  ],
};

export const hasLanguage = (language: string): ItemSearchPredicateInput => ({
  name: '_language',
  value: language,
});

export const sharedToSite = (siteId: string): ItemSearchPredicateInput => ({
  name: 'shareTo',
  value: siteId,
  operator: ItemSearchOperator.Contains,
});

export const isNotLimited = (args: {
  limitedDisplay?: string;
  siteId: string;
}): ItemSearchPredicateInput => ({
  OR: [
    // #Limited Display is not selected
    { name: 'limitedDisplay', value: '1', operator: ItemSearchOperator.Lt },
    // #Limited Display has exception for requested site
    { name: 'limitedDisplayExceptions', value: args.siteId, operator: ItemSearchOperator.Contains },
    // #Limited Display matching datasource
    args.limitedDisplay
      ? { name: 'limitedDisplay', value: args.limitedDisplay, operator: ItemSearchOperator.Eq }
      : undefined,
  ].filter((e) => e),
});

export const hasAnyCapability = (capabilityIds: string[]) => ({
  OR: capabilityIds.map((id) => ({
    name: 'articleCapabilities',
    value: id,
    operator: ItemSearchOperator.Contains,
  })),
});

export const hasAnyCategory = (categoryIds: string[]) => ({
  OR: categoryIds.map((id) => ({
    name: 'articleCategory',
    value: id,
    operator: ItemSearchOperator.Eq,
  })),
});

export const hasAnyTag = (tags: string[]) => ({
  OR: tags.map((tag) => ({
    name: 'articleTags',
    value: tag,
    operator: ItemSearchOperator.Contains,
  })),
});

export const hasAnyTheme = (themeIds: string[]) => ({
  OR: themeIds.map((id) => ({
    name: 'articleThemes',
    value: id,
    operator: ItemSearchOperator.Contains,
  })),
});

export const hasAllCapabilities = (capabilityIds: string[]) => ({
  AND: capabilityIds.map((id) => ({
    name: 'articleCapabilities',
    value: id,
    operator: ItemSearchOperator.Contains,
  })),
});

export const idIsNot = (articleId: string) => ({
  name: '_path',
  value: articleId,
  operator: ItemSearchOperator.Neq,
});

export const hasAnyId = (articleIds: string[]) => ({
  OR: articleIds.map((id) => ({
    name: '_path',
    value: id,
    operator: ItemSearchOperator.Contains,
  })),
});

export const hasCategory = (categoryId: string) => ({
  name: 'articleCategory',
  value: categoryId,
  operator: ItemSearchOperator.Contains,
});

export const hasThemeId = (themeId: string) => ({
  name: 'articleThemes',
  value: themeId,
  operator: ItemSearchOperator.Contains,
});
